import { useFrame, useThree } from '@react-three/fiber';

import { stats } from '../components/misc/floating-boxes/PerformanceStatisticsFloatingBox';
import { getLayoutModeCameraControlsOrNull, registerReactThreeFiber } from './reactThreeFiberBindings';
import { updateViewCenter } from './viewCenter';

interface Props {
  getViewportDiv: () => HTMLDivElement | null;
  getCanvasElement: () => HTMLCanvasElement | null;
}

export function ReactThreeFiberBridge({ getViewportDiv, getCanvasElement }: Props) {
  registerReactThreeFiber(useThree(), getCanvasElement, getViewportDiv);

  useFrame(({ camera, gl, scene }) => {
    const controls = getLayoutModeCameraControlsOrNull();
    if (controls) {
      controls.update();
      updateViewCenter(controls.target);
    }

    stats?.begin();
    gl.render(scene, camera);
    stats?.end();
  }, 1);

  return null;
}
